import React from "react";
import { hobbiesData } from "../../constant/constant";
import ProgressiveImage from "../ProgressiveImage";
const Hobby = () => (
  <section id="hobbies" className="section">
    <p className="eyebrow">Outside the screen</p>
    <h2 className="section-title">The things that recharge me.</h2>
    <div className="hobby-grid">
      {hobbiesData.map((hobby) => (
        <article className="hobby-card" key={hobby.name}>
          <ProgressiveImage src={hobby.image} alt={hobby.name} />
          <span>{hobby.name}</span>
        </article>
      ))}
    </div>
  </section>
);
export default Hobby;
